import { jsx as _jsx } from "react/jsx-runtime";
import { MenuItem, Skeleton, Tooltip } from '@/core/ui';
import { useAppDispatch, useAppLocalStorage } from '@/warehouse/hooks';
import { OuterContainer, PreventForwardRefBox, SelectStyled } from './ActiveLocationSelect.styled';
import { t } from '@/core/localization';
import { useLayoutStore } from '@/shared/modules/layout/business';
import { baseApi } from '@/warehouse/baseApi';
import { defaultStockLocationId } from '@/warehouse/constants';
import { stocksApi } from '@/warehouse/modules/stocks/business';
import { appSections } from '@/warehouse/navigation';
import { locationHubSignalrConnector } from '@/warehouse/signalR/locationHubSignalrConnector';
import { useNavigate } from 'react-router-dom';
const ActiveLocationSelect = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const sidebarCollapsed = useLayoutStore((state) => state.sidebarCollapsed);
    const [stockLocationId, storeStockLocationId] = useAppLocalStorage({
        key: 'stockLocationId',
        initialValue: defaultStockLocationId,
    });
    // Simple `useNamedQuery` (useGetStockLocationsQuery) forces to refetch the data for some reason, nevertheless this
    // query had already been fetched inside `initiateCrossdocksAndLocations` thunk. The following approach works as
    // expected, without duplicated request.
    const { data: items, isFetching } = stocksApi.endpoints.getStockLocations.useQuery();
    const handleChange = (event) => {
        const locationId = event.target.value;
        storeStockLocationId(locationId);
        /*
        // TODO: to delete later (old approach with different apis)
        dispatch(pickingApi.util.resetApiState());
        dispatch(stockReceiptApi.util.resetApiState());
        dispatch(stocksApi.util.resetApiState());
        dispatch(storageApi.util.resetApiState());
        */
        // Now, when all apis are the same base api, the following approach should be used:
        //
        // dispatch(productApiService.util.invalidateTags(["getProductsTag"]));
        // dispatch(userApiService.util.invalidateTags(["getUserOrdersTag"]));
        //
        // or try updateQueryData
        //
        // dispatch(productApiService.util.updateQueryData("getProducts", undefined, () => []));
        // dispatch(userApiService.util.updateQueryData("getUserOrders", undefined, () => []));
        dispatch(baseApi.util.resetApiState());
        // DO NOT MOVE to render space.
        // The connector is a lazily created singleton: its constructor opens the socket and dispatches to the store.
        // Resolving it here, inside the event handler, keeps those side effects out of the render phase —
        // calling it in the component body would dispatch to the store while React is rendering.
        // Moving this call here has fixed the following bug: https://global-parts.atlassian.net/browse/GPI-605
        locationHubSignalrConnector().reconnect();
        // Replace is necessary since user should not be able to move back to a previous stock UTD after he had selected a
        // new stock location.
        navigate(appSections.picking.getLinkTo(locationId), { replace: true });
    };
    if (isFetching)
        return (_jsx(OuterContainer, { children: _jsx(Skeleton, { height: "inputSmall" }) }));
    if (!items?.length)
        return (_jsx(OuterContainer, { children: _jsx(SelectStyled, { size: "small", disabled: true, value: 1, hideText: sidebarCollapsed, children: _jsx(MenuItem, { value: 1, children: sidebarCollapsed ? '' : t('empty.label') }, 1) }) }));
    return (_jsx(OuterContainer, { children: _jsx(Tooltip, { arrow: true, disableHoverListener: !sidebarCollapsed, title: items.find((item) => item.id === stockLocationId)?.name ?? t('empty.label'), placement: "right", enterDelay: 0, leaveDelay: 0, children: _jsx(PreventForwardRefBox, { children: _jsx(SelectStyled, { size: "small", value: stockLocationId, hideText: sidebarCollapsed, onChange: handleChange, children: items.map((item) => (_jsx(MenuItem, { value: item.id, children: item.name }, item.id))) }) }) }) }));
};
export { ActiveLocationSelect };
